import React from 'react';
import { MdEditLocation,} from 'react-icons/lib/md';
import BaseService from '../services/BaseService';
import _ from 'lodash';

export default class PinLocalization extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      lat: '',
      lng: '',
      data: [],
      loading: false,
      error_message: "",
    };
    this.getParkingSpot = this.getParkingSpot.bind(this);

    // Get position
    if('geolocation' in navigator){
      const refThis = this
      navigator.geolocation.getCurrentPosition(
        function(position){
          if( position.coords.latitude !== 0 && position.coords.longitude !== 0 ){
            refThis.setState({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            });
          }
        },
        function(error){
          console.log(error);
        }
      );
    }
  }
  getParkingSpot() {
    const url = BaseService.ENDPOINT + this.props.api;
    fetch(url,  {
      method: 'GET',
      headers: new Headers({
       Accept: 'application/json',
        Authorization: 'Bearer ' + this.props.user.access_token
      })
    })
    .then(results => {
      return results.json();
    })
    .then(data => {
      if(data.return.code === 1){
        this.setState({ data : data.data });
      }else if(data.return.code === -403){
        window.location = '/';
      }
    })
  }
  // dispatching an action based on state change
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.reload !== this.props.reload) {
      this.getParkingSpot();
    }
  }
  componentDidMount(){
    this.getParkingSpot();
  }
  render() {
    const ComponentFather = this.props.fatherNode;
    return (
      <ComponentFather
        bootstrapURLKeys={{key: BaseService.KeyGoogleMap }}
        defaultCenter={{lat: -20.697846, lng: -44.826184}}
        defaultZoom={15}
        center={{lat: this.props.lat, lng: this.props.lng}} >
        {
          _.map(this.state.data, (obj) => {
            return (
              <div
                key={obj.id}
                id={obj.id}
                className='DivPinLocalization'
                onClick={ () => {this.props.alterStatusSpot(obj)}}
                /* lat={obj.latitude}
                lng={obj.longitude} */
                title={'Número da Vaga: '+obj.spot_number+'\nEndereço: '+obj.address+', nº '+obj.address_number} >
                <span className='PinLocalizationText'>{obj.spot_number}</span>
                <MdEditLocation className="PinLocalization" style={{color: obj.status.color}} />
              </div>
            )
          }
        )
      }
      </ComponentFather>
    )
  };
};


// WEBPACK FOOTER //
// ./src/components/PinLocalization.js